import { Theme } from '@mui/material';


const Form = (theme: Theme) => {
  return {
  };
};

export default Form;
